import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const spinCustomerRoutes = {
  name: 'spin-customer',
  path: 'spin-customer',
  component: () => import('./SpinCustomer.vue'),
  meta: { i18n, kiosk: true, fullscreen: { requirePin: true, pinAction: 'spin_customer' } },
} satisfies RouteRecordRaw;
